import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Dashboard
export const getDashboardStats = () => api.get("/dashboard/stats");

// Projects
export const getProjects = (params) => api.get("/projects", { params });
export const getProject = (id) => api.get(`/projects/${id}`);
export const createProject = (data) => api.post("/projects", data);
export const updateProject = (id, data) => api.put(`/projects/${id}`, data);
export const deleteProject = (id) => api.delete(`/projects/${id}`);

// Uploads
export const uploadFiles = (projectId, formData) =>
  api.post(`/projects/${projectId}/uploads`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const getUploads = (projectId) => api.get(`/projects/${projectId}/uploads`);
export const deleteUpload = (projectId, fileId) =>
  api.delete(`/projects/${projectId}/uploads/${fileId}`);

// Analysis
export const runAnalysis = (projectId) => api.post(`/projects/${projectId}/analyze`);
export const getAnalyses = (projectId) => api.get(`/projects/${projectId}/analyses`);
export const getAnalysis = (projectId, analysisId) =>
  api.get(`/projects/${projectId}/analyses/${analysisId}`);

// Reports
export const generateReport = (projectId, data) =>
  api.post(`/projects/${projectId}/reports`, data || {});
export const getReports = (projectId) => api.get(`/projects/${projectId}/reports`);
export const getReport = (projectId, reportId) =>
  api.get(`/projects/${projectId}/reports/${reportId}`);
export const regenerateSection = (projectId, reportId, sectionName) =>
  api.post(`/projects/${projectId}/reports/${reportId}/regenerate-section?section_name=${sectionName}`);
export const exportReport = (projectId, reportId, format) =>
  api.get(`/projects/${projectId}/reports/${reportId}/export/${format}`, { responseType: "blob" });

// Diary
export const getDiaryEntries = (projectId) => api.get(`/projects/${projectId}/diary`);
export const createDiaryEntry = (projectId, data) =>
  api.post(`/projects/${projectId}/diary`, data);
export const updateDiaryEntry = (projectId, entryId, data) =>
  api.put(`/projects/${projectId}/diary/${entryId}`, data);
export const deleteDiaryEntry = (projectId, entryId) =>
  api.delete(`/projects/${projectId}/diary/${entryId}`);
export const answerDiaryFollowup = (projectId, entryId, data) =>
  api.post(`/projects/${projectId}/diary/${entryId}/followup`, data);
export const synthesizeDiary = (projectId) =>
  api.post(`/projects/${projectId}/diary/synthesize`);
export const transcribeAudio = (formData) =>
  api.post("/transcribe", formData, { headers: { "Content-Type": "multipart/form-data" } });

// Chat
export const sendChatMessage = (data) => api.post("/chat", data);
export const getChatHistory = (projectId) =>
  api.get("/chat/history", { params: { project_id: projectId } });
export const clearChatHistory = (projectId) =>
  api.delete("/chat/history", { params: { project_id: projectId } });
